import {
  dateFormat,
  maskPhoneNumber,
  priceFormat,
} from "components/utils/comm";
import ImageUploadEditor from "./imgUpEditor";
import { useTranslation } from "react-i18next";
import Img from "components/img";

export default function CellRenderer(props: any) {
  const { t } = useTranslation();
  let field = props.colDef.field;
  const type = props.colDef.type;
  const data = props.data;

  if (type === "date") {
    return <div>{dateFormat(props.value)}</div>;
  }

  if (type.includes("price")) {
    const field1 = field.split("_")[0];
    const field2 = field.split("_")[1];

    const pay = priceFormat({ price: data[field1] });
    const cnlFee = priceFormat({ price: data[field2] });

    // return type.includes("slice") ? pay + "/" + ref : pay;
    return (
      <div className="text-right">
        <p className="h-5">{pay}</p>
        {!!field2 && <p>{` / ${cnlFee}`}</p>}
      </div>
    );
  }

  if (type.includes("phone")) {
    return <div>{maskPhoneNumber(data[field])}</div>;
  }
  if (type === "img") {
    const img = props.data.url || props.data.thumImgPhUrl;
    // const result = <img src={img} alt="" />;
    const result = <Img src={img} alt={props.data.resImgNm} />;
    return result;
  }

  if (type === "detail") {
    const result = (
      // <div className="w-full flex justify-center pointer-events-none">
      <button className="btn bg-navy-300 text-white rounded-sm h-full center">
        {t("grid_detail")}
      </button>
      // </div>
    );
    return result;
  }
  if (type === "delete") {
    const result = (
      <div className="w-full flex justify-center pointer-events-none">
        <button className="btn bg-red-500 flex justify-center items-center">
          삭제
        </button>
      </div>
    );
    return result;
  }
  if (type === "modify") {
    const result = (
      <div className="w-full flex justify-center ">
        <button className="btn bg-gray-500 flex justify-center items-center">
          수정
        </button>
      </div>
    );
    return result;
  }

  if (type === "uYn-btn") {
    const bg =
      props.colDef.field === "uYn" && props.data.uyn === "Y"
        ? "bg-green-500"
        : props.data.uyn === "N"
        ? "bg-red-500"
        : "white";

    const result = (
      <button
        className={` ${bg} w-[60px] text-white font-bold rounded-sm h-[21px]`}
      >
        {props.value}
      </button>
    );
    return result;
  }

  if (type === "img-modify") {
    return <ImageUploadEditor data={props.data} />;
  }
  if (type === "modify") {
    const result = <button className="btn bg-navy-300">수정</button>;
    return result;
  }

  return props.value ?? "--";
}
